import PropTypes from "prop-types";

import "./style.scss";

const ModalEvent = ({ event }) => (
    <div className="ModalEvent">
      <div className="ModalEvent__imageContainer">
        <img
          data-testid="card-image-testid"
          src={event.cover}
          alt={event.title}
        />
      </div>
      <div className="ModalEvent__title">
        <div className="ModalEvent__titleLabel">{event.title}</div>
        <div className="ModalEvent__titlePeriode">{event.periode}</div>
      </div>
      <div className="ModalEvent__descriptionContainer">
        <h3>Description</h3>
        <div>{event.description}</div>
      </div>
      <div className="ModalEvent__descriptionContainer">
        <h3>Participants</h3>
        <div>{event.nb_guesses} participants</div>
      </div>
      <div className="ModalEvent__descriptionContainer">
        <h3>Prestations</h3>
        {event.prestations.map((presta) => (
          <div key={presta}>{presta}</div>
        ))}
      </div>
    </div>
  );

  ModalEvent.defaultProps = {
    event: null, // ou une valeur par défaut appropriée si nécessaire
  };
  
  ModalEvent.propTypes = {
    // eslint-disable-next-line react/forbid-prop-types
    event: PropTypes.any,
  };

export default ModalEvent;
